import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshancab() {



  const cardData = {
"keyword": "Pune to Konkan Darshan Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Konkan Darshan Cab for travelers seeking safe, affordable, and convenient coastal tour transportation. Whether you are planning a family vacation, beach tour, temple darshan, weekend trip, or Konkan exploration, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience across the Konkan region from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible customized itineraries, one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable journey through one of Maharashtra’s most scenic coastal routes.",

"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description":
      "Ganpatipule is a famous Konkan destination known for its pristine beach and the ancient Swayambhu Ganpati Temple. Travelers booking Pune to Konkan Darshan Cab often include this spiritual coastal stop."
  },
  {
    "title": "Ratnagiri City",
    "description":
      "Ratnagiri is a major coastal city in Konkan known for beaches, historical forts, and Alphonso mangoes, making it a key stop in Konkan tours."
  },
  {
    "title": "Jaigad Fort & Lighthouse",
    "description":
      "Jaigad Fort offers panoramic sea views and historical architecture, while the nearby lighthouse provides scenic coastal sightseeing."
  },
  {
    "title": "Dapoli Beaches",
    "description":
      "Dapoli is known as the 'Mini Mahabaleshwar of Konkan' and features beautiful beaches like Murud, Ladghar, and Karde for peaceful relaxation."
  },
  {
    "title": "Alibaug Coastal Region",
    "description":
      "Alibaug is a popular coastal destination near Konkan known for beaches, forts, and weekend tourism from Pune and Mumbai travelers."
  },
  {
    "title": "Murud-Janjira Fort",
    "description":
      "Murud-Janjira is a powerful sea fort located on an island, famous for its strong architecture and historical significance."
  },
  {
    "title": "Harihareshwar Temple & Beach",
    "description":
      "Harihareshwar is a sacred coastal town known for its Shiva temple and clean beaches, often included in Konkan pilgrimage tours."
  },
  {
    "title": "Diveagar Beach",
    "description":
      "Diveagar Beach is a clean and peaceful beach known for its white sand, coconut trees, and relaxing atmosphere."
  },
  {
    "title": "Shrivardhan Coastal Town",
    "description":
      "Shrivardhan is a calm beach town in Konkan known for its serene beaches and historical association with the Peshwa family."
  },
  {
    "title": "Konkan Coastal Scenic Route",
    "description":
      "The Pune to Konkan route passes through the Western Ghats, tunnels, waterfalls, and lush greenery, offering one of the most scenic road journeys in Maharashtra."
  }
],



services: [
  {
    name: "Pune to Konkan Cab",
    description: "Pune to Konkan cab service provides reliable transportation between Pune and the beautiful Konkan region with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and coastal travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip Konkan travel reservations."
  },
  {
    name: "Konkan Darshan Cab Pune",
    description: "Konkan Darshan cab Pune service offers dependable transportation for passengers planning sightseeing tours across the scenic Konkan coastline. Vehicles provide spacious seating and smooth highway travel suitable for beach holidays, temple visits, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the Konkan route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Konkan Darshan cab reservations."
  },
  {
    name: "Pune Konkan Tour Cab",
    description: "Pune Konkan tour cab service provides comfortable intercity transportation for passengers traveling for coastal tourism, sightseeing, and family vacations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys across the Konkan belt. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-way and round-trip Konkan travel requirements. Flexible booking options allow convenient tour cab reservations."
  },
  {
    name: "Konkan Sightseeing Cab Pune",
    description: "Konkan sightseeing cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for exploring the beaches, forts, temples, and scenic destinations of Konkan. Vehicles provide smooth highway and coastal route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy sightseeing cab reservations."
  },
  {
    name: "Pune to Konkan Taxi Service",
    description: "Pune to Konkan taxi service provides dependable transportation solutions for passengers traveling between Pune and Konkan with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance coastal travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for beach vacations, tourism, and family holidays. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Konkan Darshan Taxi Pune",
    description: "Konkan Darshan taxi Pune service provides transparent and reliable transportation for travelers planning trips across the Konkan coastline from Pune. Travelers can enjoy comfortable journeys with experienced drivers familiar with coastal routes and tourist destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi reservations for Konkan Darshan tours."
  },
  {
    name: "Pune Coastal Tour Cab Konkan",
    description: "Pune coastal tour cab Konkan service provides economical and comfortable transportation for travelers planning beach holidays and coastal sightseeing tours. Comfortable vehicles ensure smooth highway travel suitable for family vacations, beach visits, and tourism trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient coastal tour cab reservations."
  },
  {
    name: "Konkan Trip Cab Pune",
    description: "Konkan trip cab Pune service offers convenient transportation for passengers planning weekend getaways and holiday trips to Konkan from Pune. Comfortable vehicles provide smooth travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism, sightseeing, and family vacations. Flexible booking options allow convenient Konkan trip cab reservations."
  },
  {
    name: "Pune Konkan Travel Cab",
    description: "Pune Konkan travel cab service allows passengers to reserve comfortable transportation for exploring the Konkan region from Pune. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow instant and advance travel cab reservations."
  },
  {
    name: "Best Konkan Darshan Cab Pune",
    description: "Best Konkan Darshan cab Pune service provides affordable and premium transportation options for tourists visiting the Konkan coastline. Vehicles ensure reliable highway and coastal travel suitable for beach holidays, sightseeing, and family vacations. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Konkan tour cab reservations."
  },
  {
    name: "SUV Konkan Cab Pune",
    description: "SUV Konkan cab Pune service provides spacious transportation for families and groups traveling to Konkan from Pune. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for coastal vacations and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV cab reservations."
  },
  {
    name: "Innova Konkan Cab Pune",
    description: "Innova Konkan cab Pune service provides premium SUV transportation for passengers seeking comfortable and reliable coastal travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for beach vacations, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Sedan Konkan Cab Pune",
    description: "Sedan Konkan cab Pune service offers economical and comfortable transportation for solo travelers, couples, and small families traveling to Konkan from Pune. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for coastal journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Konkan Tour Booking Pune",
    description: "Konkan tour booking Pune service provides organized transportation and travel planning for passengers exploring the scenic Konkan region. Comfortable vehicles ensure smooth highway and coastal travel suitable for beach tours, sightseeing, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Konkan tour reservations."
  },
  {
    name: "Konkan Holiday Cab Pune",
    description: "Konkan holiday cab Pune service offers dependable transportation for passengers planning relaxing holidays and beach vacations in Konkan. Comfortable vehicles ensure smooth highway and coastal travel suitable for tourism, sightseeing, temple visits, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient holiday cab reservations."
  }
],

tableData: [
  ["Pune to Konkan Cab", "Konkan Darshan Cab Pune"],
  ["Pune Konkan Tour Cab", "Konkan Sightseeing Cab Pune"],
  ["Pune to Konkan Taxi Service", "Konkan Darshan Taxi Pune"],
  ["Pune Coastal Tour Cab Konkan", "Konkan Trip Cab Pune"],
  ["Pune Konkan Travel Cab", "Best Konkan Darshan Cab Pune"],
  ["SUV Konkan Cab Pune", "Innova Konkan Cab Pune"],
  ["Sedan Konkan Cab Pune", "Konkan Tour Booking Pune"],
  ["Konkan Holiday Cab Pune", "Pune to Konkan Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Konkan Darshan Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Konkan Darshan cab service with professional drivers, comfortable vehicles, and well-planned travel routes for smooth coastal journeys."
      },
      {
        WhyChooseheading: "Affordable Konkan Darshan Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Konkan Darshan cab pricing with transparent fare details and no hidden charges. Customers receive complete package information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Konkan Cab Availability",
        WhyChoosedescription: "Our Pune to Konkan Darshan cab service operates 24 hours a day for beach vacations, temple visits, family tours, sightseeing trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences across Konkan destinations."
      },
      {
        WhyChooseheading: "Customized Konkan Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way travel, round-trip bookings, multi-day Konkan Darshan tours, beach sightseeing, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, tourists, pilgrims, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Konkan coastal highways and ghat roads, ensuring safe driving, smooth travel, and timely arrival at every destination."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Konkan Darshan cab service?", answer: "Pune to Konkan Darshan cab service provides comfortable taxi transportation for visiting popular Konkan destinations, beaches, temples, and sightseeing locations." },
    { question: "Is Pune to Konkan Darshan cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Konkan Darshan cab service." },
    { question: "Which vehicles are available for Konkan Darshan travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a multi-day Konkan Darshan cab package?", answer: "Yes, customers can book one-day, weekend, and multi-day Konkan Darshan taxi packages." },
    { question: "Which Konkan destinations are covered in the tour?", answer: "Shivai Travels covers popular destinations like Ganpatipule, Tarkarli, Ratnagiri, Dapoli, Harihareshwar, and other Konkan tourist locations." },
    { question: "Are all Konkan Darshan taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Konkan Darshan cab service online?", answer: "Yes, customers can easily book Konkan Darshan cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Konkan Darshan cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Konkan Darshan cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Jadhav",
    feedback:
      "Shivai Travels provided an excellent Pune to Konkan Darshan cab service with a comfortable vehicle and an experienced driver who made the coastal journey smooth and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Pune to Konkan Darshan taxi service was very well organized with timely pickup and a relaxed travel experience, making our family trip to Konkan truly memorable.",
    rating: 5
  }
];




















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-konkan-cab.jpg",
  "description": "Book Pune to Konkan Darshan cab service for safe and comfortable coastal and sightseeing travel. Shivai Travels offers affordable one-way and round-trip Konkan tour packages with sedan, SUV, Innova, and luxury cab options available 24x7 for beach, hill, and temple tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-konkan-cab"
  }
};








  return (
    <div>


<Helmet>
  <title>Pune to Konkan Darshan Cab Service | Coastal Tour Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Konkan Darshan cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for Konkan sightseeing, beach tours, and holiday travel."
  />

  <meta
    name="keywords"
    content="pune to konkan cab, konkan darshan cab pune, pune konkan tour cab, konkan sightseeing cab pune, pune to konkan taxi service, konkan darshan taxi pune, pune coastal tour cab konkan, konkan trip cab pune, pune konkan travel cab, best konkan darshan cab pune, suv konkan cab pune, innova konkan cab pune, sedan konkan cab pune, konkan tour booking pune, konkan holiday cab pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkandarshancab;